import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

export interface GetOCCarrierInfoRequestParams {
  CarrierKey: number;
}

export interface OCCarrierInfoResponse {
  carrierDisplayAddress?: string;
  carrierEmail?: string;
  carrierKey?: number;
}

export const getOCCarrierInfoAPI = (params: GetOCCarrierInfoRequestParams) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.OVERCHARGE_CLAIM}/GetCarrierInfo`,
  });
};

export const fetchOCCarrierInfo = async (params: GetOCCarrierInfoRequestParams): Promise<OCCarrierInfoResponse> => {
  const response: AxiosResponse<OCCarrierInfoResponse> = await getOCCarrierInfoAPI(params);
  return response.data;
};
